import { getTranslationValues } from '../hooks/useTranslations';
import { IVitalSign } from '../store/slices/vitalSigns';

const bodyWeightNames = new Set(
  [
    ...getTranslationValues('vitalSignProperties.body_weight'),
    ...getTranslationValues('vitalsigns.body.weight'),
  ].map((name) => name.trim().toLowerCase())
);

export const isBodyWeight = (vital: IVitalSign) =>
  bodyWeightNames.has(vital.property_name.trim().toLowerCase());

export const isBodyComposition = (vital: IVitalSign) =>
  Number(vital.vital_sign_group_id_out) === 4 ||
  Number(vital.vital_sign_group_id) === 4 ||
  vital.vital_sign_group_name === 'Body Composition';
